<div
  class="form-control-static table-column-prefilled-text rich-generated-content"
  [innerHTML]="column.content | safeHtml"
></div>
